import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { ContactTemp } from './contact-temp.model';
import { ContactTempService } from './contact-temp.service';
@Injectable()
export class ContactTempPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private contactTempService: ContactTempService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.contactTempService.find(id).subscribe((contactTemp) => {
                contactTemp.updated = this.datePipe
                    .transform(contactTemp.updated, 'yyyy-MM-ddThh:mm');
                contactTemp.created = this.datePipe
                    .transform(contactTemp.created, 'yyyy-MM-ddThh:mm');
                this.contactTempModalRef(component, contactTemp);
            });
        } else {
            return this.contactTempModalRef(component, new ContactTemp());
        }
    }

    contactTempModalRef(component: Component, contactTemp: ContactTemp): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.contactTemp = contactTemp;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact-temp/contact-temp-popup.service.ts